import { render, staticRenderFns } from "./LvCaptcha.vue?vue&type=template&id=6f72e324"
import script from "./LvCaptcha.vue?vue&type=script&lang=js"
export * from "./LvCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports